function mapScreenshotUrl(value) {
  if (value == null || value === '') return ''
  return String(value)
}

function mapCta(cta, slug) {
  const ctaLabel = cta?.name || ''

  if (!cta) {
    return {
      ctaType: '',
      connectType: slug,
      ctaLink: '',
      ctaLabel: '',
    }
  }

  if (cta.kind === 'connect') {
    return {
      ctaType: 'connect',
      connectType: cta.providerKey || slug,
      ctaLink: '',
      ctaLabel,
    }
  }

  if (cta.kind === 'contact_us') {
    const email = cta.contactEmail || ''
    return {
      ctaType: 'contact_us',
      connectType: slug,
      ctaLink: email ? `mailto:${email}` : '',
      ctaLabel,
    }
  }

  if (cta.kind === 'hyperlink') {
    return {
      ctaType: 'hyperlink',
      connectType: slug,
      ctaLink: cta.externalUrl || '',
      ctaLabel,
    }
  }

  return {
    ctaType: '',
    connectType: slug,
    ctaLink: '',
    ctaLabel,
  }
}

export function mapIntegrationItem(item) {
  const slug = item.slug || ''
  const cta = mapCta(item.cta, slug)

  return {
    id: slug,
    title: item.name || '',
    shortDescription: item.shortDescription || '',
    badgeLabel: item.label || '',
    logoUrl: item.logoUrl || '',
    categoryLabel: item.category?.name || '',
    ...cta,
    permissions: item.permissions || [],
    accessPermissions: item.cta?.accessPermissions || [],
    overviewHtml: item.overview || '',
    keyFeaturesHtml: item.keyFeatures || '',
    howItWorksHtml: item.howItWorks || '',
    overviewImage: mapScreenshotUrl(item.overviewScreenshotUrl),
    keyFeaturesImage: mapScreenshotUrl(item.keyFeaturesScreenshotUrl),
    howItWorksImage: mapScreenshotUrl(item.howItWorksScreenshotUrl),
    howItWorksVideoUrl: item.howItWorksVideoUrl || '',
    displayIndex: item.displayIndex ?? null,
    order: item.order ?? 0,
  }
}

export function mapCategoriesFromApi(apiCategories = []) {
  return (apiCategories || []).map(category => ({
    id: category.id,
    name: category.name || '',
    displayIndex: category.displayIndex ?? null,
    order: category.order ?? 0,
    integrations: (category.items || []).map(mapIntegrationItem),
  }))
}
